import { observable, action } from 'mobx';
import RootStore, { useRootStore } from './index';

export class AppStore {
  _rootStore: RootStore;
  @observable title = 'KMS';

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
  }

  @action setTitle(title: string) {
    this.title = title;
  }
}

export const useAppStore = () => {
  const store = useRootStore();
  if (!store.app) throw new Error('AppStore has not been initialized');
  return store.app;
};
